import apiUrls from '../../youwell-common/apiUrls';
import ReduxStoreHelper from '../../youwell-common/ReduxStoreHelper';
import { getCurrentProgramData } from '../../common/utils/programUtils';

const ACTION_PREFIX = 'STUDENT_CODE';
const PROGRAMDETAILS_RECEIVED = 'PROGRAMDETAILS_RECEIVED';

const storeHelper = new ReduxStoreHelper(ACTION_PREFIX);

export const actionCreators = {
    // ...storeHelper.defaultActionCreators(apiUrls.portal.public),
    getProgramFromCode: storeHelper.createGetElementActionCreator(`${apiUrls.app.public}/code`, PROGRAMDETAILS_RECEIVED),
};

const initialState = {
    ...storeHelper.defaultInitialState,
};

export const reducer = (state, action) => {
    switch (action.type) {
    case `${ACTION_PREFIX}/${PROGRAMDETAILS_RECEIVED}`: {
        return {
            ...state,
            details: {
                ...state.details || {},
                [action.reducerParams.code]: {
                    ...action.data,
                    ...getCurrentProgramData(action.data),
                },
            },
        };
    }
    default: {
        const stateFromDefaultActions = storeHelper.defaultReducer(state, action, initialState);

        if (stateFromDefaultActions !== null) {
            return stateFromDefaultActions;
        }
    }
    }

    return state || initialState;
};
